import React, { useRef, useState } from 'react';
import { View } from '@shared/components/View';
import { NativeDropdownButton } from '@shared/components/dropdown';
import { MBIconV2 } from '@shared/components/image';
import { MBTouchableOpacity } from '@shared/components/touchable';
import { MBTextBody1Bold } from '@shared/components/typography';
import { Batch } from '@shared/scenes/cards/entityBulkActions/BatchCreateContext/BatchContext';
import { Colors, grid } from '@shared/styles';
import { MBActionSheet } from '@shared/util/actionSheet';
import { i18n } from '@shared/util/i18n';
import { useMonthOptions } from './hooks/useMonthOptions';

export function MonthOptionsMobile({
  rruleOptions,
  setRruleOptions,
}: Pick<Batch, 'rruleOptions' | 'setRruleOptions'>) {
  const dateSelectContainerRef = useRef<MBTouchableOpacity>(null);
  const [showDateSelectMenu, setShowDateSelectMenu] = useState(false);
  const nthSelectContainerRef = useRef<MBTouchableOpacity>(null);
  const [showNthSelectMenu, setShowNthSelectMenu] = useState(false);
  const daySelectContainerRef = useRef<MBTouchableOpacity>(null);
  const [showDaySelectMenu, setShowDaySelectMenu] = useState(false);

  const {
    dateSelectOptions,
    nthSelectOptions,
    daySelectOptions,
    handleDayOfMonthSelect,
    handleFullNthSelect,
    isDayOfMonthSelected,
    isNthWeekdaySelected,
    dayOfMonthDisplay,
    nthDayDisplay,
    nthDayWeekdayDisplay,
  } = useMonthOptions({ rruleOptions, setRruleOptions });

  const handleDayOfMonthSelectMenuOpen = () => {
    setShowDateSelectMenu(true);
    MBActionSheet.show({
      parent: dateSelectContainerRef.current ?? undefined,
      webVerticalAlignment: 'below',
      webHorizontalAlignment: 'left',
      onClose: () => setShowDateSelectMenu(false),
      options: dateSelectOptions,
    });
  };

  const handleNthMenuOpen = () => {
    setShowNthSelectMenu(true);
    MBActionSheet.show({
      parent: nthSelectContainerRef.current ?? undefined,
      webVerticalAlignment: 'below',
      webHorizontalAlignment: 'left',
      onClose: () => setShowNthSelectMenu(false),
      options: nthSelectOptions,
    });
  };

  const handleDayMenuOpen = () => {
    setShowDaySelectMenu(true);
    MBActionSheet.show({
      parent: daySelectContainerRef.current ?? undefined,
      webVerticalAlignment: 'below',
      webHorizontalAlignment: 'left',
      onClose: () => setShowDaySelectMenu(false),
      options: daySelectOptions,
    });
  };

  return (
    <View>
      <MBTextBody1Bold>
        {i18n('workflowTemplate.component.dateAndRepeat.onDotDotDot')}
      </MBTextBody1Bold>
      <View
        row
        centerVertically
        paddingTop={1}
        paddingBottom={1}
        style={{
          flexShrink: 1,
          flexGrow: 0,
          width: '100%',
        }}
      >
        <MBTouchableOpacity
          style={{ display: 'flex', marginRight: grid(0.5), flexShrink: 0, flexGrow: 0 }}
          onPress={handleDayOfMonthSelect}
        >
          {isDayOfMonthSelected && (
            <MBIconV2 color={Colors.v2.green} name="radio-button" size={grid(5)} />
          )}

          {!isDayOfMonthSelected && (
            <MBIconV2 color={Colors.v2.green} name="unfilled-circle" size={grid(5)} />
          )}
        </MBTouchableOpacity>
        <NativeDropdownButton
          containerRef={dateSelectContainerRef}
          onPress={handleDayOfMonthSelectMenuOpen}
          disabled={!showDateSelectMenu}
        >
          {dayOfMonthDisplay}
        </NativeDropdownButton>
      </View>
      <View
        row
        centerVertically
        paddingTop={1}
        paddingBottom={1}
        style={{
          flexShrink: 1,
          flexGrow: 0,
          width: '100%',
        }}
      >
        <MBTouchableOpacity
          style={{ display: 'flex', marginRight: grid(0.5), flexShrink: 0, flexGrow: 0 }}
          onPress={handleFullNthSelect}
        >
          {isNthWeekdaySelected && (
            <MBIconV2 color={Colors.v2.green} name="radio-button" size={grid(5)} />
          )}

          {!isNthWeekdaySelected && (
            <MBIconV2 color={Colors.v2.green} name="unfilled-circle" size={grid(5)} />
          )}
        </MBTouchableOpacity>
        <NativeDropdownButton
          containerRef={nthSelectContainerRef}
          onPress={handleNthMenuOpen}
          disabled={!showNthSelectMenu}
          style={{ flexGrow: 0, flexShrink: 1 }}
        >
          {nthDayDisplay}
        </NativeDropdownButton>
        <NativeDropdownButton
          containerRef={daySelectContainerRef}
          onPress={handleDayMenuOpen}
          disabled={!showDaySelectMenu}
        >
          {nthDayWeekdayDisplay}
        </NativeDropdownButton>
      </View>
    </View>
  );
}
